export default __webpack_public_path__ + "static/firefox.83ecc047435ce0a141da85a550608f04.png";